@defer (on viewport) {
<py-reel-cutting-modal></py-reel-cutting-modal>
} @placeholder {
<div></div>
}
